import { NewGridThemeKey, Theme } from "../export";

export const getBrandCustom = (color: keyof Theme, defaultColor: string): string => {
  try {
    const brandCustomData = window.localStorage.getItem(NewGridThemeKey);
    if (!brandCustomData) return defaultColor;

    const brandCustom = JSON.parse(brandCustomData) as Theme;

    return (brandCustom[color] as string) || defaultColor;
  } catch (error) {
    return defaultColor;
  }
};
